import { render, staticRenderFns } from "./resources.component.html?vue&type=template&id=9cd7759c&scoped=true&external"
import script from "./resources.component.ts?vue&type=script&lang=ts&external"
export * from "./resources.component.ts?vue&type=script&lang=ts&external"
import style0 from "./resources.component.scss?vue&type=style&index=0&id=9cd7759c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd7759c",
  null
  
)

export default component.exports